<template>
  <ContentTemplate title="Integrations">
    <div class="row project-management">
      <div class="row">

        <h4 v-if="isWsOwnerOrAdmin()">Tools</h4>
        <IntegrationCardWidget v-if="isWsOwner" :item="jiraIntegration"/>
        <IntegrationCardWidget v-if="isWsOwner" :item="azureIntegration"/>
        <IntegrationCardWidget v-if="isWsOwnerOrAdmin()" :item="figmaIntegration"/>
        <IntegrationCardWidget v-if="isWsOwnerOrAdmin()" :item="googleDriveIntegration"/>

        <h4>MCP <span>(Beta)</span> <NewLabelElement top-position="-2px" right-position="0" alignment="left" style="position: relative"/></h4>
        <McpCardWidget :item="cursorIntegration"/>
        <McpCardWidget :item="claudeIntegration"/>
        <McpCardWidget :item="githubCopilotIntegration"/>
      </div>
    </div>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {ContentTemplate, IntegrationCardWidget} from '@shared/components'
import {IntegrationNs} from "@shared/types";
import {IntegrationTypesConstants} from "@shared/constants";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import NewLabelElement from "@shared/components/elements/labels/new-label.element.vue";
import {isWsOwnerOrAdmin} from "@shared/mixins/role-manager";
import McpCardWidget from "@shared/components/widgets/content-card/mcp-card.widget.vue";

export default defineComponent({
  name: 'IntegrationsView',
  methods: {isWsOwnerOrAdmin},
  components: {
    McpCardWidget,
    ContentTemplate,
    IntegrationCardWidget,
    NewLabelElement
  },
  setup() {
    // initialize the store
    const workspaceStore = useWorkspaceStore()
    const integrationStore = useIntegrationStore()
    return {workspaceStore, integrationStore}
  },
  computed: {
    workspaceIntegrations(): IntegrationNs.IntegrationInfo[] {
      return this.integrationStore.getWorkspaceIntegrations
    },
    isWsOwner(): boolean {
      return ['OWNER'].includes(this.workspaceStore.getWorkspaceRole);
    }
  },
  data() {
    return {
      jiraIntegration: IntegrationTypesConstants.JIRA,
      azureIntegration: IntegrationTypesConstants.AZURE,
      figmaIntegration: IntegrationTypesConstants.FIGMA,
      googleDriveIntegration: IntegrationTypesConstants.GOOGLE_DRIVE,
      cursorIntegration: IntegrationTypesConstants.CURSOR,
      claudeIntegration: IntegrationTypesConstants.CLAUDE,
      githubCopilotIntegration: IntegrationTypesConstants.GITHUBCOPILOT
    }
  },

  beforeMount() {
    this.jiraIntegration = {
      typeInfo: {...this.jiraIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.JIRA)
      }
    }
    this.azureIntegration = {
      typeInfo: {...this.azureIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.AZURE)
      }
    }
    this.figmaIntegration = {
      typeInfo: {...this.figmaIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.FIGMA)
      }
    }
    this.googleDriveIntegration = {
      typeInfo: {...this.googleDriveIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.GOOGLE_DRIVE)
      }
    }
    this.cursorIntegration = {
      typeInfo: {...this.cursorIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.CURSOR)
      }
    }
    this.claudeIntegration = {
      typeInfo: {...this.claudeIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.CLAUDE)
      }
    }
    this.githubCopilotIntegration = {
      typeInfo: {...this.githubCopilotIntegration},
      data: {
        ...this.workspaceIntegrations.find((integration: IntegrationNs.IntegrationInfo) =>
            integration.integrationType === IntegrationNs.IntegrationTypeEnums.GITHUBCOPILOT)
      }
    }

    // this.projectManagement.push({
    //   ...IntegrationTypesConstants.TRELLO,
    //   count: integrationCounts.get('TRELLO'),
    // });

    // this.projectManagement.push({
    //   ...IntegrationTypesConstants.PIVOTAL,
    //   count: integrationCounts.get('PIVOTAL'),
    // });

    // this.notificationFeeds.push({
    //   ...IntegrationTypesConstants.SLACK,
    //   count: integrationCounts.get('SLACK'),
    // });
  }
})
</script>

<style lang="scss" scoped>
h4 {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin: var(--space-16) var(--space-0) var(--space-24);
  font-weight: 500;
  &:first-child {
    margin: var(--space-0) var(--space-0) var(--space-24);
  }
  span{
    color: var(--text-neutral);
  }
}
</style>
